import { CE_NOTIFIED_BODY_NUMBER, MANUFACTURER, PRODUCT_NAME, REGULATORY, UDI_DI } from '@/lib/regulatory';

interface ReportFooterProps {
    pageNumber: number;
    totalPages: number;
}

/**
 * Footer rendered at the bottom of each A4 report page. Carries the
 * condensed regulatory labelling strip required by ESCLOUD-76 alongside
 * the page number; included in the html2canvas rasterization (SDS-CLI-009).
 */
export function ReportFooter({ pageNumber, totalPages }: ReportFooterProps) {
    return (
        <div className="mt-auto border-t border-gray-200 pt-2 text-[9px] text-gray-400">
            <div className="flex items-center justify-between">
                <span>
                    {MANUFACTURER.name} — {PRODUCT_NAME} v{REGULATORY.softwareVersion} — CE{' '}
                    {CE_NOTIFIED_BODY_NUMBER} — UDI: {UDI_DI}
                </span>
                <span>
                    Page {pageNumber} / {totalPages}
                </span>
            </div>
            <div className="italic">This software is a medical device. Consult Instructions for Use.</div>
        </div>
    );
}
